module.exports = __webpack_public_path__ + "010ade97b31cdadd5b3a3675694e8620.png";